// eslint-disable react/jsx-closing-tag-location
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './index.less';

const cx = classNames.bind(styles);

const propTypes = {
  children: PropTypes.element.isRequired,
  // type currently accept 'small' and 'large'. If need more styles, please add to the index.less file.
  type: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  actions: PropTypes.element,
  actionPosition: PropTypes.string
};
const defaultProps = {
  type: 'small',
  title: '',
  subtitle: null,
  actions: null,
  actionPosition: 'bottom-right'
};

const AuthContainer = ({
  children,
  type,
  title,
  subtitle,
  actions,
  actionPosition,
  containerClass
}) => (
  <div className={classNames(cx('auth-container', type), containerClass)}>
    {actions && actionPosition === 'top-right' &&
        (<Fragment>
          <div className={cx('auth-container-actions-top-right')}>
            {actions}
          </div>
          <div className={cx('auth-container-spacer')} />
        </Fragment>)
      }
    {title &&
      <div className={cx('auth-container-title')}>
        {title}
      </div>
    }
    {subtitle &&
      <div className={cx('auth-container-subtitle')}>
        {subtitle}
      </div>
    }
    {children}
    {actions && actionPosition === 'bottom-right' &&
      <div className={cx('auth-container-actions')}>
        {actions}
      </div>
    }
  </div>
);

AuthContainer.propTypes = propTypes;
AuthContainer.defaultProps = defaultProps;

export default AuthContainer;



// WEBPACK FOOTER //
// ./src/components/ui/Containers/AuthContainer.jsx